import type { Origin } from "@/types/origin";

/**
 * `/references/origins` has no slug field, but the PLP filter expects one
 * (`origin=jabama`). Derive it from the origin's baseUrl hostname, which is
 * where those slugs come from (https://www.jabama.com -> "jabama").
 */
export const getOriginSlug = (origin: Pick<Origin, "baseUrl">): string => {
  if (!origin.baseUrl) return "";

  try {
    const { hostname } = new URL(origin.baseUrl);
    return hostname.replace(/^www\./, "").split(".")[0].toLowerCase();
  } catch {
    return "";
  }
};

/** Looks an origin up by the id carried on a PDP price row. */
export const findOriginById = (
  origins: Origin[] | undefined,
  originId: number | undefined | null
): Origin | undefined => {
  if (!origins?.length || originId == null) return undefined;
  return origins.find((origin) => origin.id === originId);
};

/** Display name for a booking origin, with a safe placeholder. */
export const getOriginDisplayName = (
  origins: Origin[] | undefined,
  originId: number | undefined | null
): string => findOriginById(origins, originId)?.name || "--";
